module.exports = __webpack_public_path__ + "static/media/Father.e145ca3a.png";